import { configureStore } from "@reduxjs/toolkit";
import venturesReducer from "./slices/venturesSlice";
import venturesLogosReducer from "./slices/ventureLogosSlice";
import projectsReducer from "./slices/projectsSlice";
import projectReducer from "./slices/projectSlice";
import ventureReducer from "./slices/ventureSlice";
import legalReducer from "./slices/legalSlice";
import vacanciesReducer from "./slices/vacanciesSlice";
import milestonesReducer from "./slices/milestonesSlice";
import miscsReducer from "./slices/miscsSlice";
import seoReducer from "./slices/seoSlice";
import developmentUpdatesReducer from "./slices/developmentUpdatesSlice";

const store = configureStore({
  reducer: {
    projects: projectsReducer,
    ventures: venturesReducer,
    venturesLogos: venturesLogosReducer,
    project: projectReducer,
    venture: ventureReducer,
    legal: legalReducer,
    vacancies: vacanciesReducer,
    milestones: milestonesReducer,
    miscs: miscsReducer,
    seoPages: seoReducer,
    developmentUpdates: developmentUpdatesReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
